import React from 'react';

export const IsCreatedByApiFullyIntegratedPreverifiedToolContext = React.createContext<boolean | undefined>(undefined);

export default function useIsCreatedByApiFullyIntegratedPreverifiedTool(): boolean {
  // After migration to React 19, call React.use and throw errors if context value is undefined
  const value = React.useContext(IsCreatedByApiFullyIntegratedPreverifiedToolContext);
  return !!value;
}

export function useIsCreatedByApiFullyIntegratedPreverifiedToolLoading(): boolean {
  const value = React.useContext(IsCreatedByApiFullyIntegratedPreverifiedToolContext);
  return value === undefined;
}